export interface DateFilter {
    from?: number;
    to?: number;
}

export enum WikiSearchDocumentType {
    FILE = 'file',
    PAGE = 'page',
    GRID = 'grid',
    ALL = 'all',
}

export enum WikiSearchOrderType {
    Relevancy = 'relevancy',
    CreationDate = 'creation_date',
    ModifiedDate = 'modified_date',
}

export interface WikiSearchFilters {
    type?: WikiSearchDocumentType;

    authors?: {cloud_uid?: string; uid?: string}[];

    cluster?: string;

    created_at?: DateFilter;
    modified_at?: DateFilter;

    show_obsolete?: boolean;
}

export interface WikiSearchData {
    page_id: number;
    total_pages: number;
    total_documents: number;
    results: WikiSearchItem[];
}

export interface WikiSearchItem {
    url: string;
    slug: string;
    title: string;
    body: string;
    type: WikiSearchDocumentType;
    modified_at: number;
}

export interface WikiSearchAuthor {
    name: string;
    cloudId: string;
}
